<div class="sort-headers">
	@for (sortHeader of sortHeaders; track sortHeader) {
		<div class="sort-header" (click)="changeSortOrder(sortHeader)">
			<span class="header">{{ sortHeader.label }}</span>
			@if (sortState.active == sortHeader.sortTarget.join(".")) {
				<app-icon name="arrow-down" [rotate]="sortState.direction === 'asc' ? 180 : 0" color="typography-5"></app-icon>
			}
		</div>
	}
</div>
